import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core";
import React from "react";

type SkeletonBoxProps = WithStyles<typeof styles>;

const styles = (theme: Theme) =>
    createStyles({
        box: {
            backgroundColor: theme.palette.background.default,
            borderRadius: 20,
            height: 100,
            marginBottom: theme.spacing(3),
            maxWidth: theme.bodyContent.maxWidth,
            width: "100%"
        }
    });

function SkeletonBox({ classes }: SkeletonBoxProps) {
    return <div className={classes.box} data-testid="SkeletonBox" />;
}

export default withStyles(styles)(SkeletonBox);
